import {
  useVideoStreamSetCompanyTagsMutation,
  SmartLkVideoStreamPureSetCompanyTagsInput,
} from '@shared/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from '@shared/api/graphql/types';

export type VideoStreamSetCompanyTagResultType = BaseMutationResultType;

export type UsePointSetCompanyTagsType = [
  request: (input: SmartLkVideoStreamPureSetCompanyTagsInput) => Promise<boolean>,
  result: VideoStreamSetCompanyTagResultType,
];

const useVideoStreamSetCompanyTags = (): UsePointSetCompanyTagsType => {
  const [createMutation, createMutationResult] = useVideoStreamSetCompanyTagsMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: SmartLkVideoStreamPureSetCompanyTagsInput) => {
    const newTag = await createMutation({
      variables: {
        input,
      },
    });

    return !!newTag.data?.smartlkVideoStreamPureSetCompanyTags?.ok;
  };

  const result: VideoStreamSetCompanyTagResultType = {
    error: createMutationResult.error,
    loading: createMutationResult.loading,
    called: createMutationResult.called,
  };

  return [request, result];
};

export default useVideoStreamSetCompanyTags;
